module.exports = __webpack_public_path__ + "static/img-20-8d46e9c6e58283b0108b0d69542d8117.jpeg";